import localeModule from 'timeago.js/lib/lang/en_US'
const localeName = 'en_US'
export default { locale: localeName, module: localeModule }
